import { useFormContext } from './form';
import React from 'react';
import { FormField } from './FormField';
import { FormCheckbox } from './FormCheckbox';
import { FormSelect } from './FormSelect';

const inputsByType = {
    number: FormField,
    checkbox: FormCheckbox,
    select: FormSelect,
    'select-fitted': FormSelect,
};

export function FormInputCol(props) {
    return (
        <div className="col-xs-3 flexed">
            <FormInput {...props} />
        </div>
    );
}

export function FormInput(props) {
    const form = useFormContext();
    const conf = form.config[props.name];
    const Component = inputsByType[conf.type] || conf.render;
    if (Component) {
        return <Component form={form} {...props} />;
    }

    throw new Error(`Form input type ${props.name} is not supported`);
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormInput.jsx